import React from 'react';
import { isEqual } from 'lodash';
import { Button, Col, Divider, Form, Input, Modal, Row, Select, Statistic } from 'antd';

import BaseComponent from 'base/BaseComponent';
import { enhance } from 'base/BaseEnhance';

import FhAddModal from 'components/src/fhModal/FhAddModal';

import Constants from 'constants/Constants';

import { getOptionList } from 'util/src/CommonUtil';
import { emailRule, maxMinStringRule, maxStringRule, mobileRule, zipCodeRule } from 'util/src/PatternUtil';

import FhAgreementConsent from 'view/agreementConsent/FhAgreementConsent';

import './Register.less';

const { Countdown } = Statistic;
const captchaImagePath = Constants.BACK_HOST_URI_PREFIX + '/getCaptchaImage';

/**
 * 注册
 */
class Register extends BaseComponent {
  formRef = React.createRef();
  agreementConsentRef = React.createRef();

  registerInfo = {
    setDataUrl: ''
  }

  constructor(props) {
    super(props);
    this.state = {
      registerHospitalList: [],
      modalChild: this.getModalChildInit(),
      registerFooter: this.getRegisterFooterInit(),
      isSend: false,
      verifyCodeTitle: '点击获取短信验证码',
      showVerifyCode: false,
      captchaImagePath: captchaImagePath,
      imgCaptchaChecking: false
    };

    this.formPasswdList = [
      {
        type: 'INPUT',
        label: '用户名',
        placeholder: '请输入用户名',
        field: 'loginName',
        rules: [{
          required: true,
          message: '请输入用户名'
        }, maxMinStringRule(12, 3)],
        width: 150
      },
      {
        type: 'INPUT',
        label: '手机号',
        placeholder: '请输入手机号',
        field: 'mobile',
        rules: [{
          required: true,
          message: '请输入手机号'
        }, mobileRule()],
        width: 150
      },
      {
        type: 'INPUT',
        label: '邮箱',
        placeholder: '请输入邮箱',
        field: 'email',
        rules: [emailRule()],
        width: 150
      }
    ];
    this.getRegisterHospitalList();
  }

  // 获取注册关联医院
  getRegisterHospitalList = () => {
    this.sendPostRequest('/plat-delivery/register/getRegisterHospitalList', {}, (result) => {
      this.setState({
        registerHospitalList: result || []
      });
    });
  }

  changeCaptchaImage = () => {
    this.setState({
      captchaImagePath: captchaImagePath + '?cnt=' + Math.random()
    });
  }

  // 重置form表单
  reset = () => {
    this.formRef.current && this.formRef.current.resetFields();
  }

  // 初始化时设置初始注册弹框展示元素---start----
  getModalChildInit() {
    return (
      <React.Fragment>
        <Button type="primary" style={{ marginRight: '10%' }} block onClick={this.getRegisterSupplier}
          className="fh-register-supplier">注册供应商</Button>
        <Button type="primary" block onClick={this.getRegisterSupplierUser}
          className="fh-register-supplier">注册供应商用户</Button>
      </React.Fragment>
    );
  }

  getRegisterFooterInit() {
    return [
      <Button key="back" onClick={this.modalCancel}>取消</Button>
    ];
  }
  // 初始化时设置初始注册弹框展示元素----end----

  // 注册初始元素
  getModalChildFirst = () => {
    this.reset();
    // 注册弹框初始展示
    const modalChild = this.getModalChildInit();
    // 注册弹框 按钮初始展示
    const registerFooter = this.getRegisterFooterInit();
    this.setState({ modalChild, registerFooter, showVerifyCode: false }, () => {
      this.agreementConsentRef.current && this.agreementConsentRef.current.resetAccepted();
    });
  }

  // 注册供应商弹框展示元素
  getRegisterSupplier = () => {
    const modalChild = (
      <React.Fragment>
        <Form.Item label='注册关联医院' name='registerHospitalId' key='registerHospitalId' rules={[{ required: true, message: '请选择医院' }]}>
          <Select showSearch dropdownMatchSelectWidth={true} optionFilterProp="children" placeholder="请选择关联医院">
            {getOptionList(this.state.registerHospitalList)}
          </Select>
        </Form.Item>
        <Form.Item label='供应商名称' name='supplierName' key='supplierName' rules={[{ required: true, message: '请输入供应商名称' }]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='供应商简称' name='shortName' key='shortName' rules={[{ required: true, message: '请输入供应商简称' }, maxStringRule(50)]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='地址' name='address' key='address'>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='邮编' name='zipcode' key='zipcode' rules={[zipCodeRule()]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='电话' name='telephone' key='telephone'>
          <Input type="text" />
        </Form.Item>
        <Divider dashed />
        <Form.Item label='用户名称' name='name' key='name' rules={[{ required: true, message: '请输入用户名称' },
          {
            transform: (value) => value.replace(/[^\x00-\xff]/g, '**'),// eslint-disable-line
            max: 20,
            message: '请输入全角不超过10位半角不超过20位的字符'
          }]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='登录账号' name='loginName' key='loginName' rules={[{ required: true, message: '请输入登录账号' },
          {
            transform: (value) => value.replace(/[^\x00-\xff]/g, '**'),// eslint-disable-line
            max: 20,
            message: '请输入全角不超过10位半角不超过20位的字符'
          }]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='密码' name='password' key='password' rules={[{ required: true, message: '请输入密码' }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item label='确认密码' name='confirmPassword' key='confirmPassword'
          rules={[
            { required: true, message: '请输入确认密码' }]} validateTrigger='onBlur'>
          <Input.Password />
        </Form.Item>
        <Form.Item label='手机' name='mobile' key='mobile' rules={[{ required: true, message: '请输入手机号' }, mobileRule()]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='邮箱' name='email' key='email' rules={[emailRule()]}>
          <Input type="text" />
        </Form.Item>
      </React.Fragment>
    );
    const registerFooter = [
      <Button key="lastPage" type="primary" onClick={this.getModalChildFirst}>上一步 </Button>,
      <Button key="submit" type="primary" onClick={this.registerSupplier}>提交</Button>,
      <Button key="back" onClick={this.modalCancel}>取消</Button>
    ];
    this.setState({
      modalChild,
      registerFooter,
      registerModelTitle: '第二步：注册供应商',
      showVerifyCode: true,
      isSend: false,
      verifyCodeTitle: '点击获取短信验证码'
    }, () => {
      this.changeCaptchaImage();
      this.agreementConsentRef.current && this.agreementConsentRef.current.resetAccepted();
    });
  }

  // 注册供应商用户弹框展示元素
  getRegisterSupplierUser = () => {
    const modalChild = (
      <React.Fragment>
        <Form.Item label='登录账号' name='loginName' key='loginName' rules={[{ required: true, message: '请输入登录账号' }]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='密码' name='password' key='password' rules={[{ required: true, message: '请输入密码' }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item label='确认密码' name='confirmPassword' key='confirmPassword' rules={[{ required: true, message: '请输入确认密码' }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item label='用户名称' name='name' key='name' rules={[{ required: true, message: '请输入用户名称' }]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='手机' name='mobile' key='mobile' rules={[{ required: true, message: '请输入手机号' }, mobileRule()]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='邮箱' name='email' key='email' rules={[emailRule()]}>
          <Input type="text" />
        </Form.Item>
        <Form.Item label='供应商' name='supplierName' key='supplierName' rules={[{ required: true, message: '请输入供应商名称' }]}>
          <Input type="text" />
        </Form.Item>
      </React.Fragment>
    );
    const registerFooter = [
      <Button key="lastPage" type="primary" onClick={this.getModalChildFirst}>上一步 </Button>,
      <Button key="submit" type="primary" onClick={this.registerSupplierUser}>提交</Button>,
      <Button key="back" onClick={this.modalCancel}>取消</Button>
    ];
    this.setState({
      modalChild,
      registerFooter,
      registerModelTitle: '第二步：注册供应商用户',
      showVerifyCode: true,
      isSend: false,
      verifyCodeTitle: '点击获取短信验证码'
    }, () => {
      this.changeCaptchaImage();
      this.agreementConsentRef.current && this.agreementConsentRef.current.resetAccepted();
    });
  }

  // 注册完成弹框展示元素
  getRegisterSuccess = () => {
    const modalChild = (
      <React.Fragment>
        <div style={{ margin: '10px', marginLeft: '50px', textAlign: 'left' }}>您已经成功注册，我们正在审核您提交的信息。</div>
        <div style={{ margin: '10px', textAlign: 'right', marginRight: '75px' }}>谢谢！</div>
        <div style={{ textAlign: 'right', marginRight: '50px' }}>峰禾供应链平台</div>
      </React.Fragment>
    );
    const registerFooter = [
      <Button key="back" onClick={this.modalCancel}>确定</Button>
    ];
    this.setState({ modalChild, registerFooter, registerModelTitle: '第三步：注册信息提交反馈', showVerifyCode: false });
  }

  // 弹框收起
  modalCancel = () => {
    this.setState({
      passwdVisible: false,
      registerVisible: false,
      isSend: false,
      verifyCodeTitle: '点击获取短信验证码'
    });
  }

  // 注册提交供应商
  registerSupplier = () => {
    this.registerInfo.setDataUrl = '/plat-delivery/register/registerSupplier';
    this.formRef.current && this.formRef.current.submit();
  }

  // 注册提交供应商用户
  registerSupplierUser = () => {
    this.registerInfo.setDataUrl = '/plat-delivery/register/registerSupplierUser';
    this.formRef.current && this.formRef.current.submit();
  }

  onFinish = (key) => {
    if (!isEqual(key.password, key.confirmPassword)) {
      this.showMessage('确认密码与密码不一致');
      return;
    }
    const submitData = { ...key };
    delete submitData.agreementAccepted;
    if (this.state.showVerifyCode) {
      const agreementIdList = this.agreementConsentRef.current
        && this.agreementConsentRef.current.getAgreementIdList();
      if (agreementIdList && agreementIdList.length) {
        submitData.agreementIdList = agreementIdList;
      }
    }
    this.sendPostRequest(this.registerInfo.setDataUrl, submitData, () => {
      this.getRegisterSuccess();
    });
  }

  // 忘记密码
  forgetPasswd = (key) => {
    this.sendPostRequest('/plat-delivery/register/forgetPasswd', key, () => {
      this.showMessage('密码已重置，请注意查收短信！', 'success');
      this.modalCancel();
    });
  }

  // 发送验证码
  sendVerifyCode = () => {
    if (!this.sendMobile) {
      this.showMessage('请输入手机号');
      return;
    }
    if (!this.imgCaptcha) {
      this.showMessage('请输入图形验证码');
      return;
    }

    this.setState({
      isSend: false
    });

    // 将图形验证码一并传给后端，后端校验通过才真正发送短信
    this.sendPostRequest('/plat-delivery/register/sendVerifyCode',
      { mobile: this.sendMobile, captcha: this.imgCaptcha },
      () => {
        this.setState({
          isSend: true,
          verifyCodeTitle: this.getCountdown()
        });
      },
      (errorMsg) => {
        // 失败时刷新图形验证码
        this.showMessage(errorMsg || '发送验证码失败');
        this.changeCaptchaImage();
        this.setState({
          isSend: false,
          verifyCodeTitle: '点击获取短信验证码'
        });
      }
    );
  }

  getCountdown = () => {
    return (<React.Fragment>重新获取短信验证码(<Countdown value={Date.now() + 1000 * 60} suffix='s' format="ss" onFinish={() => { this.setState({ isSend: false, verifyCodeTitle: '点击获取短信验证码' }); }} />)</React.Fragment>);
  }

  // 手机号变化时
  onValuesChange = (changedValues, allValues) => {
    this.sendMobile = allValues.mobile;
    this.imgCaptcha = allValues.imgCaptcha;
  }

  render() {
    const {
      passwdVisible, registerVisible, registerModelTitle, modalChild, registerFooter,
      showVerifyCode, captchaImagePath
    } = this.state;
    const layout = {
      labelCol: {
        sm: { span: 6 }
      },
      wrapperCol: {
        sm: { span: 18 }
      }
    };
    return (
      <React.Fragment>
        <div className="fh-register-links">
          <Button type="link" className="fh-register-link" onClick={() => { this.setState({ passwdVisible: true }); }}>忘记密码</Button>
          <Button type="link" className="fh-register-link" onClick={() => { this.getModalChildFirst(); this.setState({ registerVisible: true, registerModelTitle: '第一步选择注册类型' }); }}>用户注册</Button>
        </div>
        {/* 忘记密码 */}
        <FhAddModal visible={passwdVisible} modalTitle='忘记密码' onCancel={this.modalCancel} onCreate={this.forgetPasswd}
          formList={this.formPasswdList} width={500} span={1} okText={'提交'} />
        {/* 供应商用户注册 */}
        <Modal className='addModal' max-height={850} visible={registerVisible} title={registerModelTitle} onCancel={this.modalCancel}
          formList={this.formAddList} footer={registerFooter}>
          <Form {...layout} layout="horizontal" ref={this.formRef} onFinish={this.onFinish} onValuesChange={this.onValuesChange}>
            {modalChild}
            {showVerifyCode && (
              <React.Fragment>
                {/* 图形验证码 */}
                <Form.Item label="图形验证码">
                  <Row gutter={8} align="middle">
                    <Col span={10}>
                      <Form.Item
                        name="imgCaptcha"
                        key="imgCaptcha"
                        noStyle
                        rules={[{ required: true, message: '请输入图形验证码' }]}
                      >
                        <Input autoComplete="off" />
                      </Form.Item>
                    </Col>
                    <Col
                      span={14}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <img
                        alt="验证码"
                        src={captchaImagePath}
                        onClick={this.changeCaptchaImage}
                        height={32}
                        style={{ cursor: 'pointer', width: 120 }}
                      />
                      <Button
                        onClick={this.changeCaptchaImage}
                        style={{ marginLeft: 8, height: 32, padding: '0 12px' }}
                      >
                        看不清
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>

                {/* 短信验证码 */}
                <Form.Item label="验证码">
                  <Row gutter={8}>
                    <Col span={10}>
                      <Form.Item
                        name="verifyCode"
                        key='verifyCode'
                        noStyle
                        rules={[{ required: true, message: '请输入获取的验证码' }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={14}>
                      <Button onClick={this.sendVerifyCode} disabled={this.state.isSend}>{this.state.verifyCodeTitle}</Button>
                    </Col>
                  </Row>
                </Form.Item>
              </React.Fragment>
            )}
            {showVerifyCode && (
              <FhAgreementConsent
                ref={this.agreementConsentRef}
                mode="form"
                checkLogin={false}
                formRef={this.formRef}
              />
            )}
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default enhance(Register);
